import * as React from 'react';
import { Field } from '../dynamic-input-field/DynamicInputField';

import style from './DynamicCheckBoxField.module.css';

type DynamicInputFieldProps = {
    api: any,
    field: Field,
}

const DynamicCheckBoxField = (props: DynamicInputFieldProps) => {
    const dataStore = props.api.getDataStore(props.field);
    const [isValid, setValid] = React.useState(true);

    if (dataStore.get(props.field.name) == undefined) {
        const checkBoxField: any = {}
        props.field.metadata?.forEach((field: any) => {
            checkBoxField[field.FormQuestionFieldID] = false;
        });
        dataStore.put(props.field.name, checkBoxField);
    }

    const handleOnChange = (e: any) => {
        const checkBoxField = dataStore.get(props.field.name);
        checkBoxField[e.target.name] = e.target.checked;
        props.field.validation?.();
    };

    const validationStyling = isValid ? style.valid : style.invalid;

    props.field.validation = () => {
        const checkBoxField = dataStore.get(props.field.name);
        if (props.field.required) {
            let count = 0;
            props.field.metadata?.forEach((field: any) => {
                if (checkBoxField[field.FormQuestionFieldID]) {
                    count++;
                }
            });
            if (count == 0) {
                setValid(false);
                return false;
            }
            if (props.field.minimumValue) {
                if (count < props.field.minimumValue) {
                    setValid(false);
                    return false;
                }
            }
            if (props.field.maximumValue && props.field.maximumValue > 0) {
                if (count > props.field.maximumValue) {
                    setValid(false);
                    return false;
                }
            }
        }
        setValid(true);
        return true;
    };

    return (
        <div id={style.container}>
            <div id={style.fieldName}>{props.field.text}{props.field.required ? '*' : ''}</div>
            {
                props.field.metadata?.map((field: any, index: number) => {
                    return (
                        <div id={style.field} className={validationStyling} key={index + '_' + props.field.name + '_' + field.name + '_' + field.type}>
                            <input id={style.checkbox} onChange={handleOnChange} name={field.FormQuestionFieldID} type='checkbox' defaultChecked={dataStore.get(props.field.name)[field.FormQuestionFieldID]}></input>
                            <label id={style.text}>{field.Name}</label>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default DynamicCheckBoxField;